import { getApplicationSettings } from 'owa-application-settings';
import type { MailboxInfo } from 'owa-client-types';
import { isOfflinePeopleDataViaPDVEnabled } from './isOfflinePeopleDataViaPDVEnabled';

export const isNewProfileLinkedContactFlowEnabled = (mailboxInfo: MailboxInfo): boolean =>
    getApplicationSettings('OnePersonView').newProfileLinkedContactExperience &&
    getApplicationSettings('Jana').lpeNova &&
    getApplicationSettings('Jana').peopleNovaPeopleApp &&
    isOfflinePeopleDataViaPDVEnabled(mailboxInfo);
